import { User as FirebaseUser } from 'firebase/auth'
import { User } from '../../types'

const mapFirebaseUserToUser = (firebaseUser: FirebaseUser): User => {
  return {
    uid: firebaseUser.uid,
    email: firebaseUser.email!,
    displayName: firebaseUser.displayName || undefined,
    photoURL: firebaseUser.photoURL || undefined,
  }
}

export { mapFirebaseUserToUser }
